<glxy-alert
  (actionClick)="actionClicked()"
  *ngIf="(registrationStage$ | async) === RegistrationStage.NotSubmitted"
  [showAction]="true"
  [showClose]="true"
  actionTitle=" {{ 'SMS_REGISTRATION.ALERT.UPDATE_INFO_ACTION_TITLE' | translate }}"
  class="alert-banner"
  [type]="alertType"
>
  <span class="bold">{{ 'SMS_REGISTRATION.ALERT.BUSINESS_INFO_REQUIRED_TITLE' | translate }} -</span>
  {{ 'SMS_REGISTRATION.ALERT.MORE_DETAILS_SUGGESTION' | translate }}
</glxy-alert>
<glxy-alert
  (actionClick)="actionClicked()"
  *ngIf="(registrationStage$ | async) === RegistrationStage.DataError"
  [showAction]="true"
  [showClose]="true"
  actionTitle="{{ 'SMS_REGISTRATION.ALERT.UPDATE_INFO_ACTION_TITLE' | translate }}"
  class="alert-banner"
  type="error"
>
  <span class="bold">{{ 'SMS_REGISTRATION.ALERT.REJECTED_TITLE' | translate }} -</span>
  {{ 'SMS_REGISTRATION.ALERT.REJECTED_SUGGESTION' | translate }}
</glxy-alert>
